import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasketList, BasketOfferDuplicate, BasketWithPrice, BookBasketOffer, PersoOffer, SelectBasketOffer } from 'app/shared/models/class/basket/basketList';
import { BookedOfferAdmin } from 'app/shared/models/class/bookedOffer/bookedOffer';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasketListService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getBookedOffers(userKey: number): Observable<FullOffer[]> {
    return this.http.get<FullOffer[]>(`${environment.apiUrl}/Basket/BookedOffer/${userKey}`);
  }

  getBookedOffersExcel(): Observable<BookedOfferAdmin[]> {
    return this.http.get<BookedOfferAdmin[]>(`${environment.apiUrl}/Basket/BookedOfferAdmin`);
  }

  sendSms(): Observable<any> {
    return this.http.get<any>(`https://bizzsms.bizzdev.net/http_api/send_sms?login=lvhdf&pass=4S8F@y+w&to=+32478474090&message=testlvhdf`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  // requete à delete ?
  updateParametersOfferByUser(myParamsOffer: PersoOffer) {
    const formData = new FormData();
    formData.append('persoBasketOfferString', JSON.stringify(myParamsOffer));

    return this.http.put(`${environment.apiUrl}/Basket/PersoBasketOffer`, formData);
  }

  bookOffer(myOrder: BookBasketOffer) {
    const formData = new FormData();
    formData.append('basketOfferString', JSON.stringify(myOrder));

    return this.http.put(`${environment.apiUrl}/Basket/Booking`, formData);
  }

  // requete à delete ?
  duplicateOffer(offerDuplicate: BasketOfferDuplicate) {
    const formData = new FormData();
    formData.append('basketOfferString', JSON.stringify(offerDuplicate));

    return this.http.put(`${environment.apiUrl}/Basket/DuplicateBasketOffer`, formData);
  }


}
